import { render, staticRenderFns } from "./BadgeListAddonGroup.vue?vue&type=template&id=69d89011&"
import script from "./BadgeListAddonGroup.vue?vue&type=script&lang=js&"
export * from "./BadgeListAddonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d89011')) {
      api.createRecord('69d89011', component.options)
    } else {
      api.reload('69d89011', component.options)
    }
    module.hot.accept("./BadgeListAddonGroup.vue?vue&type=template&id=69d89011&", function () {
      api.rerender('69d89011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Badges/BadgeListAddonGroup.vue"
export default component.exports